<template>
  <div>
    <base-header></base-header>
    <div class="container">
        <router-view></router-view>
    </div>
    <base-footer></base-footer>
   
  </div>
</template>

<script>
import baseHeader from '../layouts/partials/BaseHeader'
import baseFooter from '../layouts/partials/BaseFooter'


export default{
  components: {
    baseHeader,
    baseFooter
  }
}
</script>
